import CreatePerformanceTaskView from "@features/tools/view/performance-task-view/create-performance-task-view";

const CreatePerformanceTask = () => {
  return <CreatePerformanceTaskView />;
};

export default CreatePerformanceTask;
